import { type FC } from 'react';
import { FormField, HStack, MaskedTextInputCompact, type TestProps, usePriceMask } from '@direct-frontend/components';
import { useField, useFormInstance } from '@adv-frontend/form-kit';
import { RUBBLE_SIGN } from '../../../../lib/constants';
import { changeVariantPriceTooltipForm } from '../../model';
import { ShowDiscountButton } from '../ShowDiscountButton';
import styles from './PromotionPriceField.module.css';

type PromotionPriceFieldProps = {
    formId: string;
    isSaving: boolean;
} & TestProps;

export const PromotionPriceField: FC<PromotionPriceFieldProps> = ({
    formId,
    isSaving,
    'data-testid': dataTestId = 'PromotionPriceField',
}) => {
    const formInstance = useFormInstance({ form: changeVariantPriceTooltipForm, id: formId });

    const field = useField(formInstance.fields.promotionPrice);
    const fieldProps = field.getProps();

    const priceMaskConfig = usePriceMask({
        currencyText: RUBBLE_SIGN,
        precision: 0,
    });

    return (
        <HStack gap="16">
            <FormField className={styles.fieldLabel}>
                {(formFields) => (
                    <MaskedTextInputCompact
                        {...formFields}
                        {...fieldProps}
                        maskConfig={priceMaskConfig}
                        isLoading={isSaving}
                        label="Цена по акции"
                        isDisabled
                        size="xs"
                    />
                )}
            </FormField>
            <ShowDiscountButton
                className={styles.button}
                formId={formId}
                data-testid={`${dataTestId}.ShowDiscountButton`}
            />
        </HStack>
    );
};
